<app-sidenav>
  <mat-nav-list>
    <a mat-list-item
       [routerLink]="['' | localize]">
      <span class="material-symbols-outlined bp-icon">home</span>
      Website
    </a>
    <a mat-list-item
       [routerLink]="['/admin/products' | localize]"
       routerLinkActive="active-link">
      <span class="material-symbols-outlined bp-icon">list</span>
      {{ 'PRODUCTS.title' | translate:{ count: 0 } }}
    </a>
    <a mat-list-item
       [routerLink]="['/admin/categories' | localize]"
       routerLinkActive="active-link">
      <span class="material-symbols-outlined bp-icon">sort</span>
      {{ 'CATEGORIES.title' | translate:{ count: 0 } }}
    </a>
    <a mat-list-item
       [routerLink]="['/admin/analysis-periods' | localize]"
       routerLinkActive="active-link">
      <span class="material-symbols-outlined bp-icon">date_range</span>
      {{ 'PERIODS.title' | translate:{ count: 0 } }}
    </a>
    <a mat-list-item
       [routerLink]="['/admin/media-library' | localize]"
       routerLinkActive="active-link">
      <span class="material-symbols-outlined bp-icon">photo_library</span>
      {{ 'MEDIALIBRARY.title' | translate:{ count: 1 } }}
    </a>
    <a mat-list-item
       routerLinkActive="active-link"
       [routerLink]="['/admin/users' | localize]">
      <span class="material-symbols-outlined bp-icon">patient_list</span>
      {{ 'USERS.title' | translate:{ count: 0 } }}
    </a>
    <a mat-list-item
       routerLinkActive="active-link">
      <span class="material-symbols-outlined bp-icon">apps</span>
      {{ 'SETTINGS.title' | translate:{ count: 0 } }}
    </a>
  </mat-nav-list>
</app-sidenav>

